<nz-row>
	<nz-radio-group [(ngModel)]="selectedAudio">
		<label nz-radio-button nzValue="Hz512">512 Hz</label>
		<label nz-radio-button nzValue="Hz1024">1024 Hz</label>
		<label nz-radio-button nzValue="Hz2048">2048 Hz</label>
		<label nz-radio-button nzValue="Hz4096">4096 Hz</label>
	</nz-radio-group>
</nz-row>

<nz-row>
	<nz-radio-group [(ngModel)]="selectedDirection">
		<label nz-radio-button nzValue="left">{{ 'word.left' | translate }}</label>
		<label nz-radio-button nzValue="right">{{ 'word.right' | translate }}</label>
	</nz-radio-group>
</nz-row>

<nz-row>
	<nz-slider [(ngModel)]="volume" style="width: 150px" [nzMax]="1" [nzStep]="0.01" (ngModelChange)="setVolume()"></nz-slider>
	&nbsp;
	<nz-input-number [(ngModel)]="volume" [nzMin]="0" [nzMax]="1" [nzStep]="0.001" (ngModelChange)="setVolume()"></nz-input-number>
</nz-row>

<app-splitbutton [elements]="[audioPlayButton]"></app-splitbutton>
